import * as yup from 'yup';
import { Row, RenderConfig, Column, TextInput, EMPTY_ARRAY, NumberInput, SelectInput, BOOLEAN_OPTIONS } from 'commons-ui';
import { onChangeConfigValAction, onChangeDashboardAction } from './helper';

export const validationSchemaCreate = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	expName: yup.string().required('Experiment Name is a required field'),
	bucketSupportedList: yup.array().required('Bucket List is a required field'),
	conversionMinWithdrawalLimit: yup.string().required('Min Conversion Limit is required'),
	conversionMaxWithdrawalLimit: yup.string().required('Max Conversion Limit is required'),
	withdrawalCoolOfPeriodHours: yup.number().min(0).required('withdrawal cool off period is required'),
	minWithdrawalLimit: yup.string().required('Min Withdrawal Limit is reuqired'),
	maxWithdrawalLimit: yup.string().required('Max Withdrawal Limit is required'),
	globalCoolOfPeriodsInHours: yup.number().min(0).required('Global Cool Off Period is required'),
	minimumCommonCoolOffPeriodInHours: yup.number().min(0).required('Minimum Common Cool Off Period is required'),
	conversionCoolOfPeriodHours: yup.number().min(0).required('conversion Cool Off Period is required'),
	enableMinimumCoolOffFlow: yup.bool().required('Commonn Cool Off Period Flag is required'),
	withdrawalFeeRange: yup.array().of(
		yup.object().shape({
			withdrawalFeeStartRange: yup.string().required(),
			withdrawalFeeEndRange: yup.string(),
			withdrawalFeePercentage: yup
				.number()
				.min(0, 'Should be a positive value')
				.when('withdrawalFeeFlatValue', {
					is: (val: string) => {
						if (val) return +val?.replace(/,/g, '') > 0;
						return false;
					},
					then: yup
						.number()
						.test(
							'is-zero',
							'only one field should be positive between withdrawalFeePercentage and withdrawalFeeFlatValue',
							(val) => {
								if (val) return Number(val) === 0;
								return true;
							}
						)
				})
				.optional(),
			withdrawalFeeFlatValue: yup.string(),
			withdrawalFeeMaxValue: yup.string()
		})
	)
});

export const validationSchemaEdit = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	expName: yup.string().optional(),
	bucketSupportedList: yup.array().required('Bucket List is a required field'),
	conversionMinWithdrawalLimit: yup.string().required('Min Conversion Limit is required'),
	conversionMaxWithdrawalLimit: yup.string().required('Max Conversion Limit is required'),
	withdrawalCoolOfPeriodHours: yup.number().min(0).required('withdrawal cool off period is required'),
	minWithdrawalLimit: yup.string().required('Min Withdrawal Limit is reuqired'),
	maxWithdrawalLimit: yup.string().required('Max Withdrawal Limit is required'),
	globalCoolOfPeriodsInHours: yup.number().min(0).required('Global Cool Off Period is required'),
	minimumCommonCoolOffPeriodInHours: yup.number().min(0).required('Minimum Common Cool Off Period is required'),
	conversionCoolOfPeriodHours: yup.number().min(0).required('conversion Cool Off Period is required'),
	enableMinimumCoolOffFlow: yup.bool().required('Enable Min Off Period is required'),
	withdrawalFeeRange: yup.array().of(
		yup.object().shape({
			withdrawalFeeStartRange: yup.string().required(),
			withdrawalFeeEndRange: yup.string(),
			withdrawalFeePercentage: yup
				.number()
				.min(0, 'Should be a positive value')
				.when('withdrawalFeeFlatValue', {
					is: (val: string) => +val?.replace(/,/g, '') > 0,
					then: yup
						.number()
						.test(
							'is-zero',
							'only one field should be positive between withdrawalFeePercentage and withdrawalFeeFlatValue',
							(val) => val === 0
						)
				}),
			withdrawalFeeFlatValue: yup.string(),
			withdrawalMaxValue: yup.string()
		})
	)
});

export const FORM_FIELD_KEYS = {
	SEGMENT_NAME: 'segmentName',
	EXP_NAME: 'expName',
	BUCKET_LIST: 'bucketSupportedList',
	MIN_CONVERSION_LIMIT: 'conversionMinWithdrawalLimit',
	MAX_CONVERSION_LIMIT: 'conversionMaxWithdrawalLimit',
	WITHDRAWAL_COOLOFF_PERIOD: 'withdrawalCoolOfPeriodHours',
	MIN_WITHDRAWAL_LIMIT: 'minWithdrawalLimit',
	MAX_WITHDRAWAL_LIMIT: 'maxWithdrawalLimit',
	GLOBAL_COOLOFF_PERIOD: 'globalCoolOfPeriodsInHours',
	MIN_COMMON_COOLOFF_PERIOD: 'minimumCommonCoolOffPeriodInHours',
	CONVERSION_COOLOFF_PERIOD: 'conversionCoolOfPeriodHours',
	ENABLE_MIN_COOLOFF_PERIOD: 'enableMinimumCoolOffFlow',
	OFFER: 'offer',
	RANK: 'rank',
	WITHDRAWAL_FEE_RANGE: 'withdrawalFeeRange',
	WITHDRAWAL_FEE_START_RANGE: 'withdrawalFeeStartRange',
	WITHDRAWAL_FEE_END_RANGE: 'withdrawalFeeEndRange',
	WITHDRAWAL_FEE_PERCENTAGE: 'withdrawalFeePercentage',
	WITHDRAWAL_FEE_FLAT_VALUE: 'withdrawalFeeFlatValue',
	WITHDRAWAL_FEE_MAX_VALUE: 'withdrawalFeeMaxValue',
	MAP_VALUE: 'mapValue'
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.EXP_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.BUCKET_LIST)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.MIN_CONVERSION_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.MAX_CONVERSION_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.CONVERSION_COOLOFF_PERIOD)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.MIN_WITHDRAWAL_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.MAX_WITHDRAWAL_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.WITHDRAWAL_COOLOFF_PERIOD)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.ENABLE_MIN_COOLOFF_PERIOD)]),
		new Column([new Row(FORM_FIELD_KEYS.MIN_COMMON_COOLOFF_PERIOD)]),
		new Column([new Row(FORM_FIELD_KEYS.GLOBAL_COOLOFF_PERIOD)])
	]),
	new Row(FORM_FIELD_KEYS.WITHDRAWAL_FEE_RANGE, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.WITHDRAWAL_FEE_START_RANGE)]),
		new Column([new Row(FORM_FIELD_KEYS.WITHDRAWAL_FEE_END_RANGE)]),
		new Column([new Row(FORM_FIELD_KEYS.WITHDRAWAL_FEE_PERCENTAGE)]),
		new Column([new Row(FORM_FIELD_KEYS.WITHDRAWAL_FEE_FLAT_VALUE)]),
		new Column([new Row(FORM_FIELD_KEYS.WITHDRAWAL_FEE_MAX_VALUE)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.WITHDRAWAL_FEE_MAX_VALUE)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.MAP_VALUE)])])
];

export const EDIT_CTD_FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.EXP_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.BUCKET_LIST)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.MIN_CONVERSION_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.MAX_CONVERSION_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.CONVERSION_COOLOFF_PERIOD)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.MIN_WITHDRAWAL_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.MAX_WITHDRAWAL_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.WITHDRAWAL_COOLOFF_PERIOD)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.ENABLE_MIN_COOLOFF_PERIOD)]),
		new Column([new Row(FORM_FIELD_KEYS.MIN_COMMON_COOLOFF_PERIOD)]),
		new Column([new Row(FORM_FIELD_KEYS.GLOBAL_COOLOFF_PERIOD)])
	]),
	new Row(FORM_FIELD_KEYS.WITHDRAWAL_FEE_RANGE, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.WITHDRAWAL_FEE_START_RANGE)]),
		new Column([new Row(FORM_FIELD_KEYS.WITHDRAWAL_FEE_END_RANGE)]),
		new Column([new Row(FORM_FIELD_KEYS.WITHDRAWAL_FEE_PERCENTAGE)]),
		new Column([new Row(FORM_FIELD_KEYS.WITHDRAWAL_FEE_FLAT_VALUE)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.WITHDRAWAL_FEE_MAX_VALUE)])])
];

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.SEGMENT_NAME]: new RenderConfig()
		.setName('segmentName')
		.setLabel('Segment Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: [{ id: '1', label: 'TEST' }],
			required: true
		})
		.setToolTip('CTD Segment Name'),
	[FORM_FIELD_KEYS.EXP_NAME]: new RenderConfig()
		.setName('expName')
		.setLabel('Experiment Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: [{ id: '1', label: 'TEST' }],
			required: true,
			onChangeCallback: onChangeDashboardAction
		})
		.setToolTip('CTD Experiment Name'),
	[FORM_FIELD_KEYS.BUCKET_LIST]: new RenderConfig()
		.setName('bucketSupportedList')
		.setLabel('Bucket Supported List')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: false, edit: false }, required: true })
		.setToolTip('CTD Bucket Name'),
	[FORM_FIELD_KEYS.MIN_CONVERSION_LIMIT]: new RenderConfig()
		.setName('conversionMinWithdrawalLimit')
		.setLabel('Min. Conversion Limit(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			onChangeCallback: onChangeConfigValAction
		})
		.setToolTip('Conversion Min Withdrawal Limit'),
	[FORM_FIELD_KEYS.MAX_CONVERSION_LIMIT]: new RenderConfig()
		.setName('conversionMaxWithdrawalLimit')
		.setLabel('Max. Conversion Limit(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			onChangeCallback: onChangeConfigValAction
		}),
	[FORM_FIELD_KEYS.WITHDRAWAL_COOLOFF_PERIOD]: new RenderConfig()
		.setName('withdrawalCoolOfPeriodHours')
		.setLabel('Cool Off Period for Withdrawal(Hrs)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.MIN_WITHDRAWAL_LIMIT]: new RenderConfig()
		.setName('minWithdrawalLimit')
		.setLabel('Min. Withdrawal Limit(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			onChangeCallback: onChangeConfigValAction
		}),
	[FORM_FIELD_KEYS.MAX_WITHDRAWAL_LIMIT]: new RenderConfig()
		.setName('maxWithdrawalLimit')
		.setLabel('Max. Withdrawal Limit(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			onChangeCallback: onChangeConfigValAction
		}),
	[FORM_FIELD_KEYS.GLOBAL_COOLOFF_PERIOD]: new RenderConfig()
		.setName('globalCoolOfPeriodsInHours')
		.setLabel('Global Cool Off Period(Hrs)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.MIN_COMMON_COOLOFF_PERIOD]: new RenderConfig()
		.setName('minimumCommonCoolOffPeriodInHours')
		.setLabel('Common Cool Off Period(Hrs)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.CONVERSION_COOLOFF_PERIOD]: new RenderConfig()
		.setName('conversionCoolOfPeriodHours')
		.setLabel('Cool Off Period for Conversion(Hrs)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.ENABLE_MIN_COOLOFF_PERIOD]: new RenderConfig()
		.setName('enableMinimumCoolOffFlow')
		.setLabel('Common Cool Off Period Flag')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: BOOLEAN_OPTIONS
		}),
	[FORM_FIELD_KEYS.WITHDRAWAL_FEE_RANGE]: new RenderConfig()
		.setName('withdrawalFeeRange')
		.setLabel('Withdrawal Fee Range')
		.setRenderProps({
			isArrayField: true,
			isEditable: { create: true, edit: true },
			required: false
		}),
	[FORM_FIELD_KEYS.WITHDRAWAL_FEE_START_RANGE]: new RenderConfig()
		.setName('withdrawalFeeStartRange')
		.setLabel('Withdrawal Amount Start Range(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			onChangeCallback: onChangeConfigValAction
		}),
	[FORM_FIELD_KEYS.WITHDRAWAL_FEE_END_RANGE]: new RenderConfig()
		.setName('withdrawalFeeEndRange')
		.setLabel('Withdrawal Amount End Range(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			onChangeCallback: onChangeConfigValAction
		}),
	[FORM_FIELD_KEYS.WITHDRAWAL_FEE_PERCENTAGE]: new RenderConfig()
		.setName('withdrawalFeePercentage')
		.setLabel('Fee percentage(%)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: false
		}),
	[FORM_FIELD_KEYS.WITHDRAWAL_FEE_FLAT_VALUE]: new RenderConfig()
		.setName('withdrawalFeeFlatValue')
		.setLabel('Fee Flat Value(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: false,
			onChangeCallback: onChangeConfigValAction
		}),
	[FORM_FIELD_KEYS.WITHDRAWAL_FEE_MAX_VALUE]: new RenderConfig()
		.setName('withdrawalFeeMaxValue')
		.setLabel('Withdrawal Fee Limit(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: false,
			onChangeCallback: onChangeConfigValAction
		}),
	[FORM_FIELD_KEYS.MAP_VALUE]: new RenderConfig()
		.setName('mapValue')
		.setLabel('')
		.setRenderer(TextInput)
		.setIsCollapsible(true)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			hidden: true,
			required: true
		})
		.setToolTip('CTD Segment Name')
};

export const getFormDefaults = (
	segmentList: { id: string; label: string }[],
	expDetailsList: { id: string; label: string }[],
	bucketList: { [key: string]: string }
) => {
	return {
		segmentName: segmentList,
		bucketSupportedList: ['control', 'test'],
		conversionCoolOfPeriodHours: 1,
		conversionMinWithdrawalLimit: 100,
		conversionMaxWithdrawalLimit: 200,
		withdrawalCoolOfPeriodHours: 0,
		minWithdrawalLimit: 100,
		maxWithdrawalLimit: 200,
		globalCoolOfPeriodsInHours: 0,
		minimumCommonCoolOffPeriodInHours: 1,
		enableMinimumCoolOffFlow: true,
		withdrawalFeeRange: [{ withdrawalFeeStartRange: 1, withdrawalFeePercentage: 0 }],
		expName: expDetailsList,
		mapValue: JSON.stringify(bucketList)
	};
};
